import { Text, VStack } from '@chakra-ui/react';
import SecondaryButton from '@/components/common/buttons/SecondaryButton';
import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import { useNavigate } from '@tanstack/react-router';
import { Routes } from '@/routes';
import { useProSubscription } from '@/hooks/payment/useProSubscription';
import { CONTROL_SURFACE_SHADOW } from '@/components/ui/shadows.ts';
import { AuthLayout } from '@/components/authentication/ui/AuthLayout';
import SavedCardPaymentConfirmationDialog from '@/components/payment/SavedCardPaymentConfirmationDialog';

function ProPaymentCancelPage() {
	const navigate = useNavigate();
	const {
		initiateCheckout,
		isCheckingOut,
		isConfirmationOpen,
		savedCard,
		pendingAmountCents,
		confirmCheckout,
		cancelCheckout,
	} = useProSubscription();

	const handleReturnToProperties = () => {
		navigate({ to: Routes.PROPERTIES });
	};

	return (
		<>
			<AuthLayout title="Subscription cancelled" hideLegalLinks pro>
				<VStack gap={6} textAlign="center" w="full">
					<Text fontSize="lg" color="fg.muted">
						Your Pro subscription checkout was cancelled. You can try again or return to My Bundles.
					</Text>
					<VStack gap={3} w="full">
						<PrimaryButton
							py={2}
							onClick={initiateCheckout}
							loading={isCheckingOut}
							size="lg"
							w="full"
							bg="brand.solid"
							color="brand.contrast"
							_hover={{ bg: 'brand.solidHover', color: 'brand.contrast' }}
						>
							Try again
						</PrimaryButton>
						<SecondaryButton
							variant="outline"
							onClick={handleReturnToProperties}
							w="full"
							bg="surface.default"
							color="brand.fg"
							borderColor="border.default"
							boxShadow={CONTROL_SURFACE_SHADOW}
						>
							Return to My Bundles
						</SecondaryButton>
					</VStack>
				</VStack>
			</AuthLayout>

			<SavedCardPaymentConfirmationDialog
				title="Activate Pro Subscription?"
				isOpen={isConfirmationOpen}
				amountCents={pendingAmountCents}
				card={savedCard}
				isLoading={isCheckingOut}
				onCancel={cancelCheckout}
				onConfirm={confirmCheckout}
			/>
		</>
	);
}

export const Route = createFileRoute({
	component: ProPaymentCancelPage,
});
